import { API_BASE_URL, parseResponseData } from 'lib/api/utils';
import $fetch from 'lib/fetch';
import qs from 'qs';
import { z } from 'zod';
import {
  ApproveOrRejectPendingOrderParams,
  GetOrderDetailsByIdParams,
  GetOrderReportParams,
  GetOrdersByTypeAndStatusParams,
} from './order.requests.types';
import orderResponseSchemas from './order.responses.schemas';

const BASE_SERVICE_URL = `${API_BASE_URL}/order` as const;

export async function getOrdersReport({
  orderType,
  orderStatus,
}: GetOrderReportParams) {
  const orderTypePart = orderType ? `/${orderType}` : '';
  const orderStatusPart = orderStatus ? `/${orderStatus}` : '';

  const response = await $fetch(
    `${BASE_SERVICE_URL}/ordersReport${orderTypePart}${orderStatusPart}`,
    { responseType: 'text' }
  );

  const data = z.string().parse(response.data);

  return data;
}

export async function getOrdersByTypeAndStatus({
  orderTypes,
  orderStatuses,
  page,
  limit,
}: GetOrdersByTypeAndStatusParams) {
  const orderTypesPart = [...new Set(orderTypes)].join(',');
  const orderStatusesPart = [...new Set(orderStatuses)].join(',');

  const q = qs.stringify({ page, limit });

  const response = await $fetch(
    `${BASE_SERVICE_URL}/${orderTypesPart}/${orderStatusesPart}?${q}`
  );

  const data = parseResponseData(
    response,
    orderResponseSchemas.getOrdersByTypeAndStatus
  );

  return data;
}

export async function approveOrRejectPendingOrder({
  orderNumber,
  action,
}: ApproveOrRejectPendingOrderParams) {
  const response = await $fetch(`${BASE_SERVICE_URL}/status`, {
    method: 'POST',
    body: JSON.stringify({
      orderId: orderNumber,
      status: action,
    }),
  });

  const data = parseResponseData(
    response,
    orderResponseSchemas.approveOrRejectPendingOrder
  );

  return data;
}

export async function getOrderDetailsById({
  orderId,
  page,
  limit,
}: GetOrderDetailsByIdParams) {
  const q = qs.stringify({ page, limit });

  const response = await $fetch(`${BASE_SERVICE_URL}/detail/${orderId}?${q}`);

  const data = parseResponseData(
    response,
    orderResponseSchemas.getOrderDetailsById
  );

  return data;
}
